import client from './client';
import { EnCryptData } from '../util/CustomUtil';

export const getFilters = () => client.get(`/st/filter`);
export const getList = (param) => client.get('/st/list' + param);
export const getItem = (param) => client.get('/st/item' + param);
export const getMainList = () => client.get('/st/main');
export const getList2 = (param) => client.get('/st/list2' + param);
export const getEsList = () => client.get('/st/es');

// 공간 클립 추가
export const spaceAdd = ({ email, spaceid }) => {
    let paramdata = { email, spaceid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/space/add', params);
}

//공간 클립 제거
export const spaceDel = ({ email, spaceid }) => {
    let paramdata = { email, spaceid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/space/del', params);
}

//공간 클립 전체 제거
export const spaceDelAll = ({ email, brandid }) => {
    let paramdata = { email, brandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/space/alldell', params);
}